import * as React from 'react'

export interface ITooltipProps {
  text: string
  position?: 'top' | 'bottom' | 'right' | 'left' | 'topLeft'
}

export class Tooltip extends React.Component<ITooltipProps, {}> {
  render() {
    const position = this.props.position || 'top'

    return (
      <span data-tooltipv2={this.props.text} data-position={position}>
        {this.props.children}
      </span>
    )
  }
}
